import axios from "axios";

const InstanceGA = axios.create({
    baseURL: process.env.VUE_APP_GLOBALAUTH_API
});

export default InstanceGA;